import axios, { AxiosError, AxiosInstance } from "axios";
import { BASE_URL } from "src/config/config";
import { handleErrorMsgMapper } from "src/utils/Mapper/errorMsgMapper";

export const basicAxios: AxiosInstance = axios.create({
  baseURL: BASE_URL, // 기본 서버 주소 입력
  headers: {
    "Content-Type": "application/json",
    // "Set-Cookie":
    //   "JSESSIONID=A1B6E13BB2DC097775A38B4D4DC1028D; Path=/eco-cloud; Secure; HttpOnly; SameSite=None",
    // Authorization: `Bearer ${recoil?.token?.accessToken}`,
  },
});
basicAxios.defaults.withCredentials = true; // 요청시 쿠키 담아서 보내기 허용옵션

// authAxios.interceptors.request.use(async (config) => {

//   if (config.headers && accessToken) {
//     config.headers.authorization = `Bearer ${accessToken}`; // 헤더에 accessToken 추가
//     return config;
//   } else return await new Promise(() => {});
// });

basicAxios.interceptors.response.use(
  (config) => {
    // 응답을 받고나서 데이터 가공이 필요할때
    // accessToken 만료됐으면 refreshToken으로 재발급할것
    // refreshToken 만료시 다시 로그인 ㄱㄱ
    // console.log("------응답 받은 후-------");
    // console.log("config", config);
    // setIsLoading(false);
    return config;
  }
  // async (e: AxiosError) => {
  //   console.log("basicAxios error", e);
  //   // alert(handleErrorMsgMapper({ e }));
  // }
);
